import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const NovaRepairIcon = () => (
  <Svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
      fill="#FF9100"
      fillOpacity="0.1"
    />
    <Path
      d="M20.2511 13.2504C20.0984 13.4062 20.0129 13.6156 20.0129 13.8338C20.0129 14.0519 20.0984 14.2613 20.2511 14.4171L21.5844 15.7504C21.7402 15.9031 21.9496 15.9886 22.1678 15.9886C22.3859 15.9886 22.5953 15.9031 22.7511 15.7504L25.8928 12.6088C26.3118 13.5348 26.4387 14.5665 26.2565 15.5664C26.0743 16.5663 25.5917 17.487 24.873 18.2057C24.1543 18.9244 23.2336 19.407 22.2337 19.5891C21.2338 19.7713 20.2021 19.6445 19.2761 19.2254L13.5178 24.9838C13.1862 25.3153 12.7366 25.5015 12.2678 25.5015C11.7989 25.5015 11.3493 25.3153 11.0178 24.9838C10.6862 24.6522 10.5 24.2026 10.5 23.7338C10.5 23.2649 10.6862 22.8153 11.0178 22.4838L16.7761 16.7254C16.3571 15.7994 16.2302 14.7677 16.4124 13.7678C16.5946 12.7679 17.0772 11.8472 17.7959 11.1285C18.5146 10.4098 19.4352 9.92724 20.4351 9.74505C21.4351 9.56286 22.4668 9.68973 23.3928 10.1088L20.2594 13.2421L20.2511 13.2504Z"
      stroke="#FF9100"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
